<app-base-modal
  [title]="productCardResourceType.name"
>
  <app-new-product-card
    [productCardDialogData]="productCardDialogData"
    [isLoading]="isLoading"
    (updateProductCardInTable)="updateProductCardInTable($event)"
    (handleCloseDialog)="closeDialog($event)"
    (handleLoadingState)="loadingService.setIsLoadingState($event)"
  />
</app-base-modal>
